import { render, staticRenderFns } from "./PortalList.vue?vue&type=template&id=3c92f2ec&"
import script from "./PortalList.vue?vue&type=script&lang=js&"
export * from "./PortalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports